import React, { ReactElement } from "react";
import { Translate } from "react-redux-i18n";
import { useAppSelector } from "redux/hooks";
import {
  Typography,
  Grid,
  Box
} from "@mui/material";
import styles from './styles.module.scss'

import EventsDesktop from "../EventsDesktop";
import EventsMobile from "../EventsMobile";
import BettingDetail from "../BettingDetail"
import SystemDetail from "../SystemDetail";

export default function DetailsContent(): ReactElement {
  const playedCoupon = useAppSelector(state => state.coupon.playedCoupon);
  return (
    <Box>
      <Typography className={styles.eventsTitle}>
        <Translate value="couponDetail.eventTitle" />
      </Typography>
      <EventsDesktop />
      <EventsMobile />
      <Grid container className={styles.gridContainer}>
        <BettingDetail />
        {
          playedCoupon &&
          playedCoupon.systems.length > 0 &&
          <SystemDetail />
        }
      </Grid>
    </Box >
  )
}